<template>
    <div>   
        <h1 class="content-h1">{{title}}</h1>
        <hr class="content-hr" />
        
    </div>
</template>

<script>
export default {
    name: "Title",
    props: {
        title: String
    }
    
}
</script>

<style scoped>
 
</style>